<template>
  <b-modal
    id="modalDeleteTotalSale"
    centered
    title="Delete full sale"
    title-class="font-18"
    size="md"
    @hide="resetForm"
  >
    <div class="mb-3">
      <label for="sale_id" class="form-label">ID da Venda</label>
      <b-form-input
        id="sale_id"
        v-model="saleId"
        placeholder="Ex: 1487850"
        type="text"
        :state="!errorsForm.sale_id"
      />
      <b-form-invalid-feedback v-if="errorsForm.sale_id">{{ errorsForm.sale_id }}</b-form-invalid-feedback>
    </div>

    <template v-slot:modal-footer="{ cancel }">
      <div class="d-flex justify-content-around w-100">
        <b-button @click="cancel">Cancelar</b-button>
        <b-button variant="primary" @click="submitData">Deletar</b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import operationsService from '@services/resources/OperationsService';

const service = operationsService.build();

export default {
  name: 'modalCreateTicket',
  data() {
    return {
      saleId: '',
      errorsForm: {},
    };
  },
  methods: {
    validateFields() {
      this.errorsForm = {};

      if (!this.saleId.trim()) {
        this.errorsForm.sale_id = 'O campo IDs das vendas é obrigatório.';
        return false;
      }

      return true;
    },

    async submitData() {
      if (!this.validateFields()) return;

      try {

        await service.create({ sale_id: this.saleId }, 'delete-sale-completely');
        this.$bvToast.toast('Total deletado com sucesso', {
          title: 'Sucesso',
          variant: 'success',
          solid: true,
        });

        this.$bvModal.hide('modalCreateTicket');
        this.resetForm();
      } catch (error) {      
        let message = 'Erro ao enviar';
        if (error.response && error.response.data && error.response.data.errors) {
          if (parsedData.errors.hasOwnProperty(key)) {
                message = message.concat(parsedData.errors[key]);
              }

        } else if (error.response && error.response.data && error.response.data.message) {
          message = error.response.data.message;
        } else if (error.message) {
          message = error.message;
        }

        this.$bvToast.toast(message, {
          title: 'Erro',
          variant: 'danger',
          solid: true,
        });
      }
    },

    resetForm() {
      this.saleIdsInput = '';
      this.errorsForm = {};
    },
  },
};
</script>
